import { create } from "zustand";

import type { JobEvent } from "@/lib/ws";

interface JobEventsState {
  lastRelevantEvent: JobEvent | null;
  pushEvent: (event: JobEvent) => void;
  reset: () => void;
}

function isRelevantEvent(event: JobEvent): boolean {
  return (
    event.status === "ready" ||
    event.status === "failed" ||
    event.status === "tiles_ready" ||
    event.status === "ready_preview"
  );
}

/**
 * O último evento que muda alguma tela — e só ele.
 *
 * O histórico de até 200 eventos que este store guardava não era lido por
 * ninguém: cada mensagem do WebSocket copiava o array inteiro para escrever
 * num estado que nenhum componente assinava. Numa fila grande isso é uma cópia
 * de 200 objetos por evento, à toa.
 */
export const useJobEventsStore = create<JobEventsState>((set) => ({
  lastRelevantEvent: null,
  pushEvent: (event) =>
    set((state) =>
      isRelevantEvent(event) ? { lastRelevantEvent: event } : state,
    ),
  reset: () => set({ lastRelevantEvent: null }),
}));
